module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"showMapPreview":"Voir sur une carte"},"en":{"showMapPreview":"Show on a map"}}')
  delete Component.options._Ctor
}
